const ROW_SELECTOR = ".sticky-accordion__row[data-sa-inview]";

function playRow(row) {
  if (!row || row.classList.contains("sa-inview-played")) return;
  row.classList.add("sa-inview-played");
}

export function initStickyAccordionInview(loco) {
  const rows = Array.from(document.querySelectorAll(ROW_SELECTOR));
  if (!rows.length) return;

  const checkRows = () => {
    rows.forEach((row) => {
      if (row.classList.contains("is-inview")) playRow(row);
    });
  };

  window.addEventListener("saInview", (event) => {
    const detail = event?.detail || {};
    if (detail.way !== "enter") return;
    playRow(detail.target);
  });

  if (typeof loco?.subscribeLenisScroll === "function") {
    loco.subscribeLenisScroll(checkRows);
  } else {
    window.addEventListener("scroll", checkRows, { passive: true });
  }

  checkRows();
  requestAnimationFrame(checkRows);
}
